import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { submitContactForm } from '../../services/ContactService';
import './HomePage.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    subject: 'Contact from Home Page'
  });
  
  const [loading, setLoading] = useState(false);
  
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Please fill in all required fields');
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await submitContactForm(formData);
      console.log('Form submitted successfully:', response);
      setFormData({
        name: '',
        email: '',
        message: '',
        subject: 'Contact from Home Page'
      });
      toast.success('Message sent successfully! We will get back to you soon.');
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error(error.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <section className="contact-us">
      <div className="animated-background"></div>
      <h2 className="section-title">Contact Us</h2>
      <p className="section-subtitle">
        Have questions or need assistance? We're here to help!
      </p>
      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input 
              type="text" 
              id="name" 
              placeholder=" " 
              value={formData.name}
              onChange={handleChange}
              disabled={loading}
              required 
            />
            <label htmlFor="name">Your Name</label>
          </div>
          <div className="form-group">
            <input 
              type="email" 
              id="email" 
              placeholder=" " 
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
              required 
            />
            <label htmlFor="email">Your Email</label>
          </div>
          <div className="form-group">
            <textarea 
              id="message" 
              placeholder=" " 
              rows="5"
              value={formData.message}
              onChange={handleChange}
              disabled={loading}
              required
            ></textarea>
            <label htmlFor="message">Your Message</label>
          </div>
          <button 
            type="submit" 
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactUs;